import React from 'react'
import Layout from '~/components/Layout'
import Metadata from '~/components/Metadata'
import ZinePage from '~/components/Zine'

const Zine = () => {
  if (typeof window === 'undefined') {
    return null
  }

  return (
    <Layout
      footerColors={{
        background: '#FFDD00',
        color: '#FF5A47',
        logoFront: '#FFDD00',
        logoBack: '#FF5A47',
      }}
    >
      <Metadata title={'Zine'} />
      <ZinePage />
    </Layout>
  )
}

export default Zine
